import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import TitumAuthorization from "./@titum/core/TitumAuthorization";
import AppContext from "./AppContext";
import Layout from "./titum-layouts/Layout";
import store from "./Redux/store";
import routes from "./titum-configs/routesConfig";
import { Auth } from "./auth";
import { ChannelProvider } from "ably/react";

import "./App.css";
import { ConnectionState } from "ConnectionState";
import { CHANNEL_NAMES } from "Components/Constants/ChannelNames";

function App() {
  var pjson = require("../package.json");

  return (
    <ChannelProvider channelName={CHANNEL_NAMES.CREATE_KOT}>
      <ChannelProvider channelName={CHANNEL_NAMES.KOT_REVERSAL}>
        <AppContext.Provider
          value={{
            routes,
          }}
        >
          <Provider store={store}>
            <Auth>
              <BrowserRouter basename={pjson.url}>
                <TitumAuthorization>
                  <Layout />
                  <ConnectionState />
                </TitumAuthorization>
              </BrowserRouter>
            </Auth>
          </Provider>
        </AppContext.Provider>
      </ChannelProvider>
    </ChannelProvider>
  );
}

export default App;
